export default "__VITE_ASSET__B_21zMaY__"